import * as yup from 'yup'

type InferSchemaType<T extends yup.Schema> =
  T extends yup.Schema<infer U> ? U : never

export function mapFormDataToSchema<T extends yup.Schema>({
  formData,
  schema,
}: {
  formData: FormData
  schema: T
}): InferSchemaType<T> {
  const data: Record<string, unknown> = {}

  formData.forEach((value, key) => {
    // Handle checkboxes
    if (data[key] !== undefined) {
      if (Array.isArray(data[key])) {
        data[key].push(value)
      } else {
        data[key] = [data[key], value]
      }
    } else {
      // Handle radio buttons and other inputs
      data[key] = value
    }
  })

  // Convert checkbox values to boolean if necessary
  Object.keys(data).forEach(key => {
    if (Array.isArray(data[key]) && data[key].length === 1) {
      data[key] = data[key][0]
    }
  })

  return schema.cast(data, { assert: false, stripUnknown: true })
}
